import React from 'react';
import styles from './Loading.module.scss';
import clsx from 'clsx';
const Loading = ({ className }) => {
  return (
    <>
      <span className={clsx(styles.loader, className)}></span>
    </>
  );
};

export default Loading;
